import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'MULTI_STEP_FORM', {
  PREVIOUS_BUTTON: 'Previous',
  NEXT_BUTTON: 'Next',
  SUBMIT_BUTTON: 'Confirm the action',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'MULTI_STEP_FORM', {
  PREVIOUS_BUTTON: 'Anterior',
  NEXT_BUTTON: 'Siguiente',
  SUBMIT_BUTTON: 'Enviar',
});
